import { ArchivedJobsList } from './views/ArchivedJobsList';
import { MasterSheetEdit } from '../master-sheet-v2/views';

export default {
  edit: MasterSheetEdit,
  list: ArchivedJobsList,
  name: 'job-archived-sheet',
  label: 'Archived Jobs',
  to: '/job-archived-sheet',
};
